import type { TypeSTTConfigForm } from '@intone/shared';
import {
  ModelField,
  LanguageField,
  UseFillerWordsField,
  KeytermsField,
  PunctuateField,
  NumeralsField,
  SmartFormatField,
  ProfanityFilterField,
  EnableDiarizationField,
} from './Fields';

export type Props = {
  currentConfig: TypeSTTConfigForm;
  updateConfig: (field: keyof TypeSTTConfigForm, value: any) => void;
};

export function DeepgramFields({ currentConfig, updateConfig }: Props) {
  const modelList = [
    { label: 'Flux', value: 'flux' },
    { label: 'Nova-3', value: 'nova-3' },
    { label: 'Nova-2', value: 'nova-2' },
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4 items-start">
        <ModelField
          value={currentConfig.model}
          onUpdate={(value) => updateConfig('model', value)}
          modelList={modelList}
        />
        <LanguageField value={currentConfig.language} onUpdate={(value) => updateConfig('language', value)} />
        <KeytermsField value={currentConfig.keyterms} onUpdate={(value) => updateConfig('keyterms', value)} />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <UseFillerWordsField
          value={currentConfig.use_filler_words}
          onUpdate={(value) => updateConfig('use_filler_words', value)}
        />
        <PunctuateField value={currentConfig.punctuate} onUpdate={(value) => updateConfig('punctuate', value)} />
        <NumeralsField value={currentConfig.numerals} onUpdate={(value) => updateConfig('numerals', value)} />
        <SmartFormatField
          value={currentConfig.smart_format}
          onUpdate={(value) => updateConfig('smart_format', value)}
        />
        <ProfanityFilterField
          value={currentConfig.profanity_filter}
          onUpdate={(value) => updateConfig('profanity_filter', value)}
        />
        <EnableDiarizationField
          value={currentConfig.enable_diarization}
          onUpdate={(value) => updateConfig('enable_diarization', value)}
        />
      </div>
    </div>
  );
}